
import { useEffect } from "react";
import { Contact, Investor } from "@/types/investor";
import ContactsList from "@/components/ContactsList";

interface ContactsPageProps {
  contacts: Contact[];
  investors: Investor[];
}

const ContactsPage = ({ contacts, investors }: ContactsPageProps) => {
  // Log data whenever it changes for debugging
  useEffect(() => {
    console.log("ContactsPage - Contacts available:", contacts.length);
    console.log("ContactsPage - Investors available:", investors.length);
  }, [contacts, investors]);

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Contacts</h1>
      
      {contacts && contacts.length > 0 ? (
        <ContactsList 
          contacts={contacts} 
          investors={investors} 
        />
      ) : (
        <div className="text-center py-12">
          <p className="text-lg text-muted-foreground">No contacts data found</p>
          <p className="text-sm mt-2">Upload your investors data on the Upload Data page</p>
        </div>
      )}
    </div>
  );
};

export default ContactsPage;
